import axios from 'axios';
import { requestInter, responseInter } from './requestInter.js';
let type = process.env.VUE_APP_ENV;
import {getCookieInfo} from './getCookie.js'  
let token =  localStorage.getItem('token') || getCookieInfo('access_token')||''; 
let headers  = {}
if(token){
    headers.Authorization = 'bearer' +token ; 
} 
let fetch = axios.create({
    baseURL:  '/auth',
    headers: headers, 
    withCredentials:true,

});
requestInter(fetch);
responseInter(fetch);
export default fetch;